import { Grid } from '@mui/material';
import React, { useState } from 'react';
import { Box, Typography, Avatar, Button, IconButton, Chip, Divider, Paper } from '@mui/material';
import MedicationIcon from '@mui/icons-material/Medication';
import DeleteIcon from '@mui/icons-material/Delete';
import PersonIcon from '@mui/icons-material/Person';
import { isEmpty, map } from 'lodash';
import { useQuery, useMutation } from 'react-query';
import {
  deleteMedications,
  getRecipientMedications,
  getTodayMedications,
  getUserMedications,
  deleteUserMedications,
} from '../../../utils/api';
import CircularProgress from '@mui/material/CircularProgress';
import SnackbarComponent from '../../../components/Snackbar';
import TopBar from './TopBar';
import AddMedicationModal from '../../Medications/components/AddMedicationModal';
import { useTranslation } from 'react-i18next';

const Medicines = ({ user, recipient }) => {
  const { t } = useTranslation();
  const [deleteSnack, setDeleteSnack] = useState();
  const [showAddModal, setShowAddModal] = useState(false);
  const { data, isLoading, refetch } = useQuery(['getRecipientMedications'], () =>
    recipient?._id
      ? getRecipientMedications({ userId: user?._id, recipientId: recipient?._id })
      : getUserMedications({ userId: user?._id }),
  );

  const deleteMeds = useMutation(recipient?._id ? deleteMedications : deleteUserMedications, {
    onSuccess: (data) => {
      setDeleteSnack(true);
      refetch();
    },
    onError: (error) => {
      console.log('error =====> ', error);
    },
  });

  const handleDeleteMedications = (id) => {
    if (recipient?._id) {
      deleteMeds.mutate({ userId: user?._id, medIds: [id], recipientId: recipient?._id });
    } else {
      deleteMeds.mutate({ userId: user?._id, medIds: [id] });
    }
  };

  return (
    <Grid>
      <TopBar btnText={t('addMedication')} onClick={() => setShowAddModal(true)} />
      {isLoading && (
        <Grid marginY={10} container justifyContent={'center'}>
          <CircularProgress size={40} style={{ color: '#26786a' }} />
        </Grid>
      )}
      <AddMedicationModal
        show={showAddModal}
        onClose={() => setShowAddModal(false)}
        recipientId={recipient?._id}
        refetch={refetch}
      />
      {!isLoading && isEmpty(data?.data) && (
        <Typography variant="h5" textAlign="center" justifyContent={'center'}>
          {t('noMedicationsFound')}
        </Typography>
      )}

      {!isLoading &&
        data?.data?.map((item, key) => (
          <Paper elevation={1} sx={{ p: 3, borderRadius: 2, position: 'relative', width: '100%', mt: 2 }} key={key}>
            <Box display="flex" justifyContent="space-between" alignItems="center">
              <Box display="flex" alignItems="center" gap={1}>
                <Avatar sx={{ bgcolor: item?.color || '#26786a' }}>
                  <MedicationIcon />
                </Avatar>
                <Typography variant="h6" fontWeight="bold">
                  {item?.name}
                </Typography>
              </Box>

              <Box display="flex" justifyContent="space-between" alignItems="center">
                <Chip
                  label={
                    <Box display="flex" alignItems="center" justifyContent={'center'} gap={1}>
                      <Typography variant="caption" color="textSecondary">
                        {t('responsible')}
                      </Typography>
                      <Avatar sx={{ width: 24, height: 24, bgcolor: '#26786a' }}>
                        <PersonIcon fontSize="small" />
                      </Avatar>
                    </Box>
                  }
                  //   size="small"
                  sx={{ backgroundColor: '#f0f0f0', marginRight: '20px' }}
                />
                <Typography variant="caption" color="textSecondary">
                  {t('duration')}{' '}
                  <Typography component="span" variant="caption">
                    {item?.duration || '1'} {t('days')}
                  </Typography>
                </Typography>
                <IconButton
                  style={{ border: '0.3px solid grey', marginLeft: '20px' }}
                  onClick={() => handleDeleteMedications(item?.id)}
                >
                  <DeleteIcon fontSize="small" style={{ color: 'red' }} />
                </IconButton>
              </Box>
            </Box>

            <Divider style={{ marginBlock: '20px' }} />

            <Box display="flex" justifyContent="space-between" mt={1} mb={1}>
              <Box>
                <Typography variant="caption" color="textSecondary">
                  {t('frequency')}
                </Typography>
                <Typography>{item?.frequency}</Typography>
              </Box>
              <Box>
                <Typography variant="caption" color="textSecondary">
                  {t('dose')}
                </Typography>
                <Typography>{item?.timeFrequency[0]?.quantity}</Typography>
              </Box>
              <Box>
                <Typography variant="caption" color="textSecondary">
                  {t('time')}
                </Typography>
                <Box display="flex" gap={1}>
                  {item?.timeFrequency.map(({ time }, index) => (
                    <Chip key={index} label={time} size="small" sx={{ backgroundColor: '#f0f0f0' }} />
                  ))}
                </Box>
              </Box>
              <Box>
                <Typography variant="caption" color="textSecondary">
                  {t('howToTake')}
                </Typography>
                <Typography>{item?.howToTake}</Typography>
              </Box>
            </Box>

            <Divider style={{ marginBlock: '20px' }} />

            <Typography variant="body2" color="textSecondary" mt={1} mb={1}>
              {item?.description}
            </Typography>
          </Paper>
        ))}
      <SnackbarComponent open={deleteSnack} message={t('medicationDeleted')} />
    </Grid>
  );
};

export default Medicines;
